import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUpdateProfile({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    name,
    lastName,
    marketingOptIn,
  }: {
    name: string
    lastName: string
    /** Omit to leave the current consent unchanged. */
    marketingOptIn?: boolean
  }) => {
    const response = await httpClient.put('auth/user/profile-information', {
      name,
      last_name: lastName,
      ...(marketingOptIn === undefined
        ? {}
        : { marketing_opt_in: marketingOptIn }),
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success('Profile updated successfully')
      queryClient.invalidateQueries({ queryKey: ['current-user'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
